import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Box, Breadcrumbs, Button, Typography } from '@mui/material'

import { Circle } from '@mui/icons-material'
import { DialogsEnum } from '@/enums'
import Main from '@/views/layouts/main/index'

import ErrorLimit from '@/views/components/error-limit/index.component'
import PageTitle from '@/views/layouts/page-title/index.layout'
import BonusEngineModule from '@/views/bonus-engine/bonus-engine.module'

import {
  useBonuses,
  useBonusDialog,
  useWageringActions,
} from '@/views/bonus-engine/hooks'
import useHasAccess from '@/hooks/use-access.hook'
import { RoleType } from '@/enums/role.enum'

import routes from '@/routes'

const BonusEngine = () => {
  const { t } = useTranslation()

  const { handleCreateBonus } = useBonuses()

  const { toggleDialog } = useBonusDialog()

  const { getAllWageringCategory, getAllCategories } = useWageringActions()

  const { hasAccess } = useHasAccess()

  const handleEditWageringContribution = () => {
    getAllWageringCategory()
    getAllCategories()
    toggleDialog(true, DialogsEnum.DIALOG_WAGERING_CONTRIBUTION)
  }

  const handleEditExcludedGames = () => {
    getAllWageringCategory()
    toggleDialog(true, DialogsEnum.DIALOG_EXCLUDED_GAMES)
  }

  const title = `${t('pages.bonusProgram')}`

  const breadcrumbs = (
    <Breadcrumbs separator={<Circle sx={{ fontSize: 6, marginX: 2 }} />}>
      <Link to={routes.HOME}>
        <Typography>{t('pages.home')}</Typography>
      </Link>
      <Typography>{t('pages.bonusEngine')}</Typography>
      <Typography>{t('pages.bonusProgram')}</Typography>
    </Breadcrumbs>
  )

  return (
    <Main>
      <ErrorLimit>
        <Box mb={5} display="flex">
          <PageTitle title={title} breadcrumbs={breadcrumbs} />
          <Box display="flex" alignItems="center" flexShrink={0}>
            {!hasAccess(RoleType.AGENT) && (
              <>
                <Box mr={2}>
                  <Button
                    onClick={handleEditExcludedGames}
                    variant="outlined"
                    color="primary"
                  >
                    {t('labels.excludedGames')}
                  </Button>
                </Box>
                <Box mr={2}>
                  <Button
                    onClick={handleEditWageringContribution}
                    variant="outlined"
                    color="primary"
                  >
                    {t('wageringContributionsEdit')}
                  </Button>
                </Box>
                <Box>
                  <Button variant="contained" onClick={handleCreateBonus}>
                    {t('createBonusEngine')}
                  </Button>
                </Box>
              </>
            )}
          </Box>
        </Box>

        <BonusEngineModule />
      </ErrorLimit>
    </Main>
  )
}

export default BonusEngine
